export class ParseError extends Error {
  constructor(name: string) {
    super(name);
  }
}
